import { render, staticRenderFns } from "./app_08_c-pet_sheet.vue?vue&type=template&id=0dc46e77&lang=pug&"
import script from "./app_08_c-pet_sheet.vue?vue&type=script&lang=js&"
export * from "./app_08_c-pet_sheet.vue?vue&type=script&lang=js&"
import style0 from "./app_08_c-pet_sheet.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports